module.exports = __webpack_public_path__ + "static/media/Rest.0d50896c.jpg";